"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            SSToken: null
        };
        GState.bind(this, [
            'tenant',
            'auth'
        ]);
        this.hasFormData = this.state.auth && !!this.state.auth.formdata;
        fhandler.bind(this, this.hasFormData && this.state.auth.formdata || {});
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        fhandler.set('country', location);
        UISocket.emit('APP::GET_SSOTOKEN', {
            authType: 'signup',
            device: window.Device,
            userAgent: window.UserAgent,
            location
        }, token => this.state.SSToken = token);
    },
    onSubmit: async function (e) {
        if (!this.state.form.agree_terms || this.state.submitting)
            return;
        const Form = this.state.form;
        if (!Form.first_name)
            return this.state.formError.first_name = true;
        if (!Form.last_name)
            return this.state.formError.last_name = true;
        if (!Form.email)
            return fhandler.error('email', 'Email Address field is required');
        if (!Form.password)
            return fhandler.error('password', 'Password field is required');
        Form.device = window.Device;
        this.state.submitting = true;
        try {
            const {error, message, next} = await AuthRequest('/signup', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            window.uiStore.set('email', Form.email);
            !error && fhandler.reset();
            navigate('/' + (next || 'signin'));
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/Signup.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    module_SSOPs = require("json/SSOPs"),
    SSOPs = module_SSOPs.default || module_SSOPs,
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    SSOAuth_template = require("../../components/SSOAuth.marko"),
    SSOAuth_tag = marko_loadTag(SSOAuth_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-body"
      },
    marko_attrs1 = {
        "class": "mx-50"
      },
    marko_attrs2 = {
        "class": "mt-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c7e6b0"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "mb-1"
      },
    marko_node3 = marko_createElement("br", null, "38", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "43", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "font-medium-1 mx-50 mt-4"
      },
    marko_attrs8 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_node5 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "col"
      },
    marko_attrs10 = {
        "class": "form-group"
      },
    marko_attrs11 = {
        "class": "col"
      },
    marko_attrs12 = {
        "class": "form-group"
      },
    marko_attrs13 = {
        "class": "mt-4 font-small"
      },
    marko_attrs14 = {
        "class": "mt-4 font-small"
      },
    marko_node7 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "24", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Email Address"),
    marko_node8 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "27", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Password"),
    marko_attrs15 = {
        "class": "mt-4 font-small"
      },
    marko_attrs16 = {
        "class": "checkbox checkbox-primary"
      },
    marko_node9 = marko_createElement("label", {
        "for": "agree-terms",
        "class": "font-medium-1"
      }, "36", null, 2, 0, {
        i: marko_const_nextId()
      })
      .t("I agree to the ")
      .e("a", {
          href: "/terms"
        }, null, null, 1)
        .t("terms of user & privacy policy");

const fhandler = new FormHandler({ key: 'signup-form', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AuthLayout_tag({
      showLogo: true,
      renderBody: function(out) {
        if (state.auth && state.auth.message) {
          out.e("div", marko_attrs8, "1", component, 3)
            .n(marko_node5, component)
            .n(marko_node6, component)
            .e("p", null, "4", component, 1)
              .t(state.auth.message, component);
        }

        out.be("div", marko_attrs0, "5", component);

        FormAlert_tag({
            alert: state.alert,
            class: "mx-50"
          }, out, __component, "6");

        out.be("form", marko_attrs1, "@signup-form", component);

        out.be("h5", marko_attrs2, "7", component);

        Locale_tag({
            text: "Sign Up"
          }, out, __component, "8");

        out.ee();

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        Row_tag({
            style: "margin:0 -1.02rem",
            renderBody: function(out) {
              out.be("div", marko_attrs9, "12", component);

              out.be("div", marko_attrs10, "13", component);

              out.e("input", {
                  "class": "form-control form-control-xl",
                  type: "text",
                  required: true,
                  name: "first_name",
                  value: state.form.first_name,
                  placeholder: Locale("First Name") + "*"
                }, "14", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              if (state.formError.first_name) {
                out.be("p", marko_attrs13, "15", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Enter your First name");
                    }
                  }, out, __component, "16");

                out.ee();
              }

              out.ee();

              out.ee();

              out.be("div", marko_attrs11, "17", component);

              out.be("div", marko_attrs12, "18", component);

              out.e("input", {
                  "class": "form-control form-control-xl",
                  type: "text",
                  required: true,
                  name: "last_name",
                  value: state.form.last_name,
                  placeholder: Locale("Last Name") + "*"
                }, "19", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              if (state.formError.last_name) {
                out.be("p", marko_attrs14, "20", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Enter your Last name");
                    }
                  }, out, __component, "21");

                out.ee();
              }

              out.ee();

              out.ee();
            }
          }, out, __component, "11");

        out.be("div", marko_attrs3, "22", component);

        out.e("input", {
            "class": "form-control form-control-xl",
            type: "email",
            required: true,
            name: "email",
            value: state.form.email,
            validate: fhandler.define("email"),
            placeholder: Locale("Email Address") + "*"
          }, "23", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        if (state.formError.email) {
          out.n(marko_node7, component);
        }

        out.ee();

        out.be("div", marko_attrs4, "25", component);

        out.e("input", {
            "class": "form-control form-control-xl",
            type: "password",
            required: true,
            name: "password",
            value: state.form.password,
            placeholder: Locale("Password") + "*"
          }, "26", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        if (state.formError.password) {
          out.n(marko_node8, component);
        }

        out.ee();

        out.be("div", marko_attrs5, "28", component);

        out.e("input", {
            "class": "form-control form-control-xl",
            type: "email",
            name: "referer",
            disabled: component.hasFormData && (!(!state.auth.formdata.referer)),
            value: state.form.referer,
            validate: fhandler.define("email"),
            placeholder: Locale("Referer Email Address")
          }, "29", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        if (state.formError.referer) {
          out.be("p", marko_attrs15, "30", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Enter your Last name");
              }
            }, out, __component, "31");

          out.ee();
        }

        out.ee();

        out.n(marko_node2, component);

        out.e("div", marko_attrs6, "33", component, 1)
          .e("div", marko_attrs16, "34", component, 2)
            .e("input", {
                type: "checkbox",
                id: "agree-terms",
                name: "agree_terms",
                checked: state.form.agree_terms
              }, "35", component, 0, 0, {
                onchange: __component.d("change", "__onChecked", false)
              })
            .n(marko_node9, component);

        out.n(marko_node3, component);

        out.be("button", {
            type: "submit",
            disabled: (!state.form.agree_terms) || state.submitting,
            "class": "btn btn-primary btn-xl text-left w-100"
          }, "39", component, null, 0, {
            onclick: __component.d("click", "onSubmit", false)
          });

        if (state.submitting) {
          Preloader_tag({
              class: "float-right font-medium-5",
              active: true
            }, out, __component, "40");
        } else {
          Bx_tag({
              type: "right-arrow-alt",
              class: "font-large-1 float-right white-text"
            }, out, __component, "41");
        }

        Locale_tag({
            text: "Sign Up"
          }, out, __component, "42");

        out.ee();

        out.ee();

        out.n(marko_node4, component);

        if ((!component.hasFormData) || (!state.auth.formdata.referer)) {
          SSOAuth_tag({
              token: state.SSToken
            }, out, __component, "44");
        }

        out.be("div", marko_attrs7, "45", component);

        if (isDefaultDomain()) {
          Locale_tag({
              renderBody: function(out) {
                out.t("Already have an institution?");
              }
            }, out, __component, "46");

          out.t(" ");

          route_link_tag({
              href: "/",
              class: "font-medium-1 text-secondary",
              renderBody: function(out) {
                Locale_tag({
                    text: "Let find it"
                  }, out, __component, "48");
              }
            }, out, __component, "47");
        } else {
          Locale_tag({
              renderBody: function(out) {
                out.t("Already have an account?");
              }
            }, out, __component, "49");

          out.t(" ");

          route_link_tag({
              href: "/signin",
              class: "text-secondary",
              renderBody: function(out) {
                Locale_tag({
                    text: "Sign In",
                    class: "font-medium-1"
                  }, out, __component, "51");
              }
            }, out, __component, "50");
        }

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
